import { addBet, removeBet } from './reducers/subscription';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    BETS_PLACED: addBet,
    BETS_UNSUBSCRIBE: removeBet,
});
